export class PreferencesViewModel {
  LanguageName: string;
  LanguageId: number;
  HomePageName: string;
  HomePageId: number;
  CurrencyName: string;
  CurrencyId: number;
  UnitOfMeasurementName: string;
  FullName: string;
  PhoneNumber: string;
  StreetAddress: string;
  Suburb: string;
  PostCode: string;
  State: string;
  Country: string;
  UnitofDistance: string;
  DefaultFormCatId: number;
  DeafultUCSetupType: number;
  UCCompInspectOrderOptionId: number;
  UCEquipmentCondition: number;
  UCEquipmentConditionPage: number
  UCShowWornPerToday: number;
}


export class CurrencyViewModel {
  Id: number;
  Code: string;
  Name: string;
}

export class LanguageViewModel {
  Id: number;
  Name: string;
}

export class FormCategoryViewModel {
  Id: number;
  Name: string;
}

export class PreferenceTaskListVM {
  public TaskID: number
  public userID: number
  public TaskName: string
  public showTask: boolean
  public TaskIDSelectedList: number[]
}

export class UCComponentInspectionOrderVM {
  public ID: number
  public UserID: number
  public ComponentType: string
  public ComponentTypeId: number
  public SortOrder: number
  public InspectInReverse: boolean
}

export class EnablePreferenceTasksVM {
  public userID: number
  public showImplementAction: boolean
  public showDocLib: boolean
  public showRebuildImplement: boolean
  public showChangeJobsite: boolean
  public showUpdateUsage: boolean
  public showMoveImplement: boolean
  public showPIP: boolean
  public showImplementTarget: boolean
  public showPerformInsp: boolean
  public showModifyAst: boolean
  public showWarrantySts: boolean
  public showCopyFrmTemp: boolean
  //Equipment
  public showUpdateMeter: boolean
  public showChangeMeterUnit: boolean
  public showSetupImplemet: boolean
  public showMoveToInventory: boolean
  public showMoveFromInventory: boolean
  public showImpSortOrder: boolean
  //CRC

  public showMoveToRepair: boolean
  public showPrePostShipment: boolean
  public showReturnToInventory: boolean
  public showAttachToEquipment: boolean
  public showModifyComponent: boolean
  public showChangeStatus: boolean
  public showProjectContact: boolean
  public showProjectPartsLists: boolean

}

export class UserPreferenceDashboardFleetColumnVM {
  public userID: number
  public showModelImg: boolean
  public showEvalLR: boolean
  public showCustomer: boolean
  public showJobsite: boolean
  public showInspector: boolean
  public showSerial: boolean
  public showUnit: boolean
  public showMake: boolean
  public showModel: boolean
  public showFamily: boolean
  public showSMU: boolean
  public showLTD: boolean
  public showPropel: boolean
  public showLastInspDate: boolean
  public showLastInspSmu: boolean
  public showAdditonal: boolean;
  public showNextInsp: boolean;
  public showTherm: boolean;
  public showReplacementDate: boolean;
  public showResidual: boolean;
  public showAvgUsage: boolean;
  public showStatus: boolean;
  public showSummaryNotes: boolean;
}
export class GridColumn {
  GridId: number;
  ScreenCode: string;
  ColumnKey: string;
  ColumnDisplayName: string;
  IsActive: boolean;
  DisplayOrder: number;
  CreatedDate: Date;
  IsSelected: boolean;
  SortOrder: number;
}

export class UserGridColumnPreferenceUpdateDto {
  GridId: number;
  IsSelected: boolean;
}
export class UserGridPreferenceUpdateDto {
    ScreenCode: string;
    GridIds: number[];
}

export class UserGridPreferenceUpdateDtoNew {
  ScreenCode: string;
  Columns: UserGridPreferenceColumnDto[];
}

export class UserGridPreferenceColumnDto {
  GridId: number;
  SortOrder: number;
  IsSelected: boolean;
}
